module.exports = __webpack_public_path__ + "img/rehber.bdbd47b9.png";